// extracted by mini-css-extract-plugin
export default {"wrapper":"pA-z","viewport":"qA-z","container":"rA-z","slide":"sA-z"};